<template lang="html">
  <v-sheet class="w-100 h-100 d-flex justify-center align-center" color="transparent">
    <v-btn
      v-if="canIsolate"
      class="viewer-click-cell-renderer__button"
      @click="btnClickedHandler"
      @dblclick.native.stop.prevent
      @keydown.native.enter.stop
      color="primary"
      small
      icon
      :title="actionLabel"
      :aria-label="actionLabel">
      <v-icon small>{{ viewerIcon }}</v-icon>
    </v-btn>
  </v-sheet>
</template>

<script>
export default {
  name: 'ViewerClickCellRenderer',
  methods: {
    btnClickedHandler(event) {
      if (event?.detail > 1) return;
      if (!this.params.clicked) return;
      this.params.clicked(this.params.data);
    },
  },
  computed: {
    actionLabel() {
      return this.params.data?.__SpatialActionMode === 'relatedEquipment'
        ? 'Show related equipment in 3D' : 'Show this record in 3D';
    },
    canIsolate() {
      const predicate = this.params.colDef?.cellRendererParams?.canIsolate;
      return typeof predicate === 'function'
        ? predicate(this.params.data)
        : false;
    },
    viewerIcon() {
      return this.params.colDef?.cellRendererParams?.icon || 'mdi-cube-scan';
    },
    tagValue() {
      const tagColumn = this.params.colDef?.cellRendererParams?.tagColumn;
      if (!tagColumn || !this.params.data) return '';
      return this.params.data[tagColumn] || '';
    },
  },
};
</script>
